<template>
  <div v-show="show" class="toast toast--fixed" v-bind:class="getClass()">
    <button class="btn-close" v-on:click="close"></button>
    <h6 class="toast__title">{{ status }}</h6>
    <div class="divider"></div>
    <div v-if="isOnline">
      <p>
        Looks like you're back online. Click the
        <i class="fa fa-wrapper fa-sync-alt"></i> <strong>Sync</strong> button
        to upload your changes to the server.
      </p>
    </div>
    <div v-if="isOffline">
      <p>
        We can't detect an internet connection. Don't worry - we've cached your
        data and you can sync it with the server when you're back online.
      </p>
    </div>
  </div>
</template>
<style>
.toast--fixed {
  position: fixed !important;
  bottom: 3rem;
  left: 50%;
  width: 38rem !important;
  height: auto !important;
  z-index: 100;
  transform: translate(-50%, 0);
}
</style>
<script>
export default {
  name: "offline-notification",
  data: function() {
    return {
      show: undefined
    };
  },
  watch: {
    isOnline: function() {
      if (this.isOffline) {
        // Always show the isOffline message
        this.show = true;
      } else if (this.show != undefined) {
        // Show the isOnline message except on initial page load
        this.show = true;
        // Hide the `isOnline`  message after 5 seconds
        if (this.isOnline) {
          setTimeout(() => {
            this.show = false;
          }, 5 * 1000);
        }
      }
    }
  },
  computed: {
    status: function() {
      return this.isOnline ? "Back Online" : "Working Offline";
    }
  },
  methods: {
    getClass: function() {
      return this.isOnline ? "toast--info" : "toast--error";
    },
    close: function() {
      this.show = false;
    }
  }
};
</script>
